<template>
<div class="page page_loaction">
    <div class="search">
        <van-field v-model="keywords" placeholder="搜索附近位置" :right-icon="publicPath+'statics/images/search_gery_icon.png'"  @click-right-icon="onSearch" @blur="onSearch" />
    </div>
    <div class="list_wrap">
        <div class="list">
            <div class="item first" @click="clickPoi(0)">不显示位置</div>
			<div class="item first" v-if="city" @click="clickPoi(1)">{{ city }}</div>
        </div>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="aMapSearchNearBy(keywords)">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index" @click="clickPoi(2,item)">
					<div class="title slh_s">{{ item.name }}</div>
					<div class="address slh_s">{{ item.address }}</div>
				</div>
			</div>
        </van-list>
    </div>
	<van-overlay :show="show_overlay">
		<van-loading type="spinner" color="#1989fa"></van-loading>
	</van-overlay>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: null,
            dataList: [],
            pages: {
                page: 1,
                size: 20
            },
			keywords: null,
			loading: false,
			finished: false,
			lng: null,
			lat: null,
			locationArr: null,
			province: null, // 省
			city: null, // 市
			district: null, // 区
			show_overlay: true
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '获取位置'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
        }

	},
    mounted: function () {
        var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //获取定位信息
            var params2 = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://public/getLocationInfo', params2, (data) => {
                console.log(111111111)
                console.log(data)
                if (data.code == 200) {
                    that.lat = data.result.latitude
                    that.lng = data.result.longitude
                    AMap.service('AMap.Geocoder',function(){//回调函数
                        //实例化Geocoder
                        var geocoder = new AMap.Geocoder({
                            city: ""//城市，默认：“全国”
                        });
                        var lnglatXY = [that.lng, that.lat];//地图上所标点的坐标
                        geocoder.getAddress(lnglatXY, function(status, result) {
                            console.log(result)
                            if (status === 'complete' && result.info === 'OK') {
                                
                                var arr = []
                                arr.push(that.lng)
                                arr.push(that.lat)
                                that.locationArr = arr
                                that.province = result.regeocode.addressComponent.province
                                that.city = result.regeocode.addressComponent.city
                                that.district = result.regeocode.addressComponent.district
                                that.aMapSearchNearBy()
                                that.show_overlay = false
                                // var city = result.regeocode.addressComponent.city;
                            }else{
                                that.lng = that.$publicData.locationDefault.lng
                                that.lat = that.$publicData.locationDefault.lat
                                that.locationArr = [that.lng,that.lat]
                                console.log('111111111',that.lng,that.lat)
                                that.city = '天津市'
                                that.aMapSearchNearBy()
                                that.show_overlay = false
                            }
                        });
                    })
                } else {
                    that.lng = that.$publicData.locationDefault.lng
                    that.lat = that.$publicData.locationDefault.lat
                    that.locationArr = [that.lng,that.lat]
                    console.log('111111111',that.lng,that.lat)
                    that.city = '天津市'
                    that.aMapSearchNearBy()
                    that.show_overlay = false
                }
            })
        } else {
            // 定位
            AMap.plugin(["AMap.Geolocation"], function () {
                // 定位  Geolocation 手机端优先使用浏览器定位，失败后使用IP定位
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 10000, //超过10秒后停止定位，默认：5s
                    buttonPosition: "LB", //定位按钮的停靠位置
                    buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                    buttonDom: document.getElementById('mapBtn'), // 自定义定位按钮 对应button
                    panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
                    showMarker: false, // 定位成功后在定位到的位置显示点标记，默认：true
                    showCircle: false, // 定位成功并且有精度信息时，是否用一个圆圈circle表示精度范围
                });

                geolocation.getCurrentPosition(function (status, data) {
                    if (status == "complete") {
                        // that.onComplete(result);
                        console.log('定位成功', data)
                        var arr = []
                        arr.push(data.position.lng)
                        arr.push(data.position.lat)
                        that.locationArr = arr
                        that.province = data.addressComponent.province
                        that.city = data.addressComponent.city
                        that.district = data.addressComponent.district
                        that.lng = data.position.lng
                        that.lat = data.position.lat
                        that.aMapSearchNearBy()
                        that.show_overlay = false
                    } else {
                        if (data.message == "Geolocation permission denied") {
                            console.log("地理定位权限被拒绝！")
                        } else if (data.message == "Browser not Support html5 geolocation") {
                            console.log("浏览器不支持原生定位接口")
                        } else if (data.message == "Get geolocation time out") {
                            console.log("浏览器定位超时")
                        } else if (data.message == "Get geolocation failed") {
                            console.log("定位失败")
                        }
                        that.lng = that.$publicData.locationDefault.lng
                        that.lat = that.$publicData.locationDefault.lat
                        that.locationArr = [that.lng,that.lat]
                        console.log('111111111',that.lng,that.lat)
                        that.city = '天津市'
                        that.aMapSearchNearBy()
                        that.show_overlay = false
                    }
                });

            });
        }
            
        
    },
    methods: {
        // 高德地图根据经纬度查询周边
        aMapSearchNearBy(keywords) {
			var that = this
            AMap.service(["AMap.PlaceSearch"], function () {
                var placeSearch = new AMap.PlaceSearch({
                    pageSize: that.pages.size, // 每页10条
                    pageIndex: that.pages.page, // 获取第一页
                    city: that.city // 指定城市名(如果你获取不到城市名称，这个参数也可以不传，注释掉)
                });
                // 第一个参数是关键字，这里传入的空表示不需要根据关键字过滤
                // 第二个参数是经纬度，数组类型
                // 第三个参数是半径，周边的范围 0-50000
                // 第四个参数为回调函数
                placeSearch.searchNearBy(keywords ? keywords : '', that.locationArr, 50000, function (status, result) {
					console.log('周边获取信息',result)
                    if (result.info === 'OK') {
						var list = result.poiList.pois; // 周边地标建筑列表
						if(list.length != 0 ){
							// 只支持 1-100页
							that.dataList = that.dataList.concat(list)
							that.pages.page++
							that.loading = false
						}else{
							that.finished = true
							that.loading = false
						}
                        console.log('列表', that.dataList)
                    } else {
						// that.$toast('获取周边信息失败,请刷新重试')
						that.finished = true
						that.loading = false
                    }
                });
            });
		},
		// 搜索 模糊匹配
		onSearch(){
			var that = this;
			if(that.keywords == null || that.keywords == undefined || that.keywords ==''){
				that.$toast('请输入所查询的内容')
				return
			}else{
				that.pages.page = 1
				that.dataList = []
				that.aMapSearchNearBy(that.keywords)
			}
		},
		// 选择POI
		clickPoi(type,item){
			var that = this
			// console.log('点选POI',item)
			var obj = {
				lng: that.lng,
				lat: that.lat,
				province: that.province,
				city: that.city,
				district: that.district,
				type: type
			}
			if(type == 2){
				obj.address = item.address
				obj.landmark = item.name
			}
			localStorage.setItem('selectPoi',JSON.stringify(obj))
			setTimeout(function(){
				that.$router.back() // -1||空 回退 0刷新 1前进 
			},100)
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
